import { render, staticRenderFns } from "./selectLang.vue?vue&type=template&id=3ffa587e&scoped=true&"
import script from "./selectLang.vue?vue&type=script&lang=js&"
export * from "./selectLang.vue?vue&type=script&lang=js&"
import style0 from "./selectLang.vue?vue&type=style&index=0&id=3ffa587e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffa587e",
  null
  
)

export default component.exports